// Default `.luis` sample used by the playground on first load.
// Example: it covers loops, functions, objects, arrays, and conditional blocks.
export const defaultSource = `
:root{
--surface: #f8fbff;
--radius: 14px;
--spaceScale: [1-5];
--spaceStep: 4px;
--strings: [1,2,3];
--gridX: [1-2];
--gridXT: ['1-2',"3-4"];
--gridY: [1-2];
--objectContent: { color: #ffffff; font-size: 15px; font-weight: 600; };
--theme: { accent: #00245a; };
--card: .card { background: var(--surface); border: 1px solid #d6e5ff; border-radius: var(--radius); padding: 18px; };
--hovercard: :hover { transform: translateY(-2px); box-shadow: 0 10px 26px rgba(22, 61, 120, 0.18); };
}
--variants: [primary, secondary, danger];
--sizes: [sm, md, lg];
--breakpoints: [
{ name: sm; size: 640px }, 
 { name: md; size: 768px }
 ];

.btn {
  border: 0;
  border-radius: 10px;
  var(--objectContent);
  background-color: var(--theme.accent);
  padding: 10px 16px;
}

var(--card);
.card&var(--hovercard);
.btn &var(--hovercard);

.card .title {
  color: var(--objectContent.color);
  font-size: var(--objectContent.fontSize);
}

@for(i, var(--spaceScale)) {
  .m-\${i}{
    margin-top: \${i} * var(--spaceStep);
  }
}

@for(i, var(--gridX)) {
  @for(j, var(--gridY)) {
    .grid-\${i}-\${j} {
      padding: \${i * j}px;
      margin-top: \${i * j}px;
      border: 1px dashed #b8cdfc;
    }
  }
}
@for(i, var(--strings)) {
    .class-\${i} {
      padding: 8px;
      border: 1px dashed #b8cdfc;
    }
}
@for(i, var(--gridXT)) {
    .class-\${i} {
      padding: 8px;
      border: 1px dashed #b8cdfc;
    }
}
@for (v, var(--variants)) {
  @for (s, var(--sizes)) {
    .btn-\${v}-\${s} {
      /* variant color */
      background: var(--color-\${v});      
      /* size */
      padding: var(--space-\${s});
    }
  }
}

@for ((bp, ind), var(--breakpoints)) {
  @media (min-width: \${bp.size}) {
    .container-\${ind + 1} {
      max-width: \${bp.size};
    }
  }
}

@fun: build-tone(name, bg, text){
  .tone-\${name} { background: \${bg}; color: \${text}; border: 1px solid \${bg}; }
}
@fun.build-tone(primary, #dbe9ff, #1c3f8f);
@fun.build-tone(success, #dff7ec, #125f3e);

@fun: density(mode){
  @if(\${mode} === 'compact') { .density-\${mode} { padding: 2px 6px; } }
  else { .density-\${mode} { padding: 6px 10px; } }
}
@for(mode, [compact, relaxed]) {
  @fun.density(\${mode});
}

@if(var(--theme.accent) === '#00245a') {
  .if-demo {
    color: #0c2b61;
  }
}
elseif(var(--theme.accent) === '#000000') {
  .if-demo {
    color: #000000;
  }
}
else {
  .if-demo {
    color: #333333;
  }
}
`
